export default "__VITE_ASSET__B73$_lyS__"